import axios from 'axios'
import { API_BASE } from '../config'

const WIKI_API = 'https://oldschool.runescape.wiki/api.php';

function authHeaders() {
    return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
}

// Every request resolves to the whole event as it now stands:
// { rows, columns, startsAt, endsAt, tiles: [{ title, points, image }] (all rows x columns of them, from the top
//   left, row by row), teams: [{ id, name, color, completed }] }
// where startsAt and endsAt are when the event starts and ends (both null until they are set),
// image is the address of the tile's picture (empty if it has none) and completed lists the numbers of the
// tiles that team has done, and color is the "#rrggbb" a team is drawn in
export default class Bingo {
    // GET /bingo
    getBoard() {
        return axios.get(`${API_BASE}/bingo`).then(x => x.data);
    }

    // The rest are for Admins and Founders

    // PUT /bingo/tiles/:tile - Set what a tile says, shows and is worth
    setTile(tile, title, points, image) {
        return axios.put(`${API_BASE}/bingo/tiles/${tile}`, { title, points, image }, authHeaders()).then(x => x.data);
    }

    // POST /bingo/teams - Add a team, with the colour it is drawn in ("#rrggbb")
    addTeam(name, color) {
        return axios.post(`${API_BASE}/bingo/teams`, { name, color }, authHeaders()).then(x => x.data);
    }

    // PUT /bingo/teams/:id - Change a team's name and/or colour: changes is either or both of { name, color }
    updateTeam(id, changes) {
        return axios.put(`${API_BASE}/bingo/teams/${encodeURIComponent(id)}`, changes, authHeaders()).then(x => x.data);
    }

    // DELETE /bingo/teams/:id - Remove a team for good
    deleteTeam(id) {
        return axios.delete(`${API_BASE}/bingo/teams/${encodeURIComponent(id)}`, authHeaders()).then(x => x.data);
    }

    // PUT /bingo/teams/:id/tiles/:tile - Mark a tile as completed by a team, or not
    setCompleted(id, tile, completed) {
        return axios.put(`${API_BASE}/bingo/teams/${encodeURIComponent(id)}/tiles/${tile}`, { completed }, authHeaders()).then(x => x.data);
    }

    // PUT /bingo/times - Set when the event starts and ends (dates as text), or pass two nulls for no times
    setTimes(startsAt, endsAt) {
        return axios.put(`${API_BASE}/bingo/times`, { startsAt, endsAt }, authHeaders()).then(x => x.data);
    }

    // POST /bingo/rows - Add a row of blank tiles to the bottom of the board
    addRow() {
        return axios.post(`${API_BASE}/bingo/rows`, {}, authHeaders()).then(x => x.data);
    }

    // POST /bingo/columns - Add a column of blank tiles to the right of the board
    addColumn() {
        return axios.post(`${API_BASE}/bingo/columns`, {}, authHeaders()).then(x => x.data);
    }

    // DELETE /bingo/rows/:number - Take a row (0 is the top one) off the board for good, with its tiles
    removeRow(row) {
        return axios.delete(`${API_BASE}/bingo/rows/${row}`, authHeaders()).then(x => x.data);
    }

    // DELETE /bingo/columns/:number - Take a column (0 is the left one) off the board for good, with its tiles
    removeColumn(column) {
        return axios.delete(`${API_BASE}/bingo/columns/${column}`, authHeaders()).then(x => x.data);
    }

    // Look up Old School RuneScape Wiki pages whose names start with some text, for their pictures. This asks the
    // wiki itself, not the clomp backend. Resolves to the pages that have a picture, best match first:
    // [{ title, image }]
    searchWiki(text) {
        return axios.get(WIKI_API, {
            params: {
                action: 'query', format: 'json', origin: '*', generator: 'prefixsearch', gpssearch: text, gpslimit: 12,
                prop: 'pageimages', piprop: 'thumbnail', pithumbsize: 160
            }
        }).then((x) => {
            let pages = Object.values((x.data.query && x.data.query.pages) || {});
            return pages.filter((page) => page.thumbnail).sort((a, b) => a.index - b.index)
                .map((page) => ({ title: page.title, image: page.thumbnail.source }));
        });
    }
}
